function Footer() {
  return (


    <div className="footer-border mt-5 pt-3">
      <div className="d-flex align-items-center justify-content-around foorer-social-media">
        <a className="social-media facebook" href="https://www.facebook.com/profile.php?id=100091964926190" target="_blank"></a>
        <a className="social-media instagram" href="https://instagram.com/level_group.ua?igshid=OGQ5ZDc2ODk2ZA==" target="_blank"></a>
        <a className="social-media tiktok" href="https://tiktok.com" target="_blank"></a>
      </div>
      {/*<div className="d-flex align-items-center justify-content-center my-3">*/}
      {/*  <div className='foorer-text logo-color' style={{marginRight: '0.5rem'}}>LEVEL GROUP</div>*/}
      {/*  <div className='foorer-text logo-color'>2025</div>*/}
      {/*</div>*/}

    </div>


  );
}

export default Footer;
